{
  "lastUpdatedAt": "2026-10-05T08:26:50.061Z",
  "lastFetchAttemptAt": "2026-10-05T08:26:50.061Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}